import { useEffect, useState } from 'react';

export default function useDocumentReadyState() {
  const [readyState, setReadyState] = useState<DocumentReadyState>('loading');

  useEffect(() => {
    setReadyState(document.readyState);
    const onReadyStateChange = () => setReadyState(document.readyState);
    document.addEventListener('readystatechange', onReadyStateChange);
    return () =>
      document.removeEventListener('readystatechange', onReadyStateChange);
  }, []);

  return readyState;
}
